import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 30000
});

api.interceptors.response.use(
  response => response.data,
  error => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export const searchResources = (params) => {
  return api.get('/search', { params });
};

export const searchPoll = (params) => {
  return api.get('/search/poll', { params });
};

export const getRanking = (params) => {
  return api.get('/ranking', { params });
};

export const getHome = (params) => {
  return api.get('/home', { params });
};

export const getPanList = (params) => {
  return api.get('/pan/list', { params });
};

export const getPanDetail = (id) => {
  return api.get(`/pan/${id}`);
};

export const userRegister = (data) => {
  return api.post('/user/register', data);
};

export const userLogin = (data) => {
  return api.post('/user/login', data);
};

export const getUserInfo = (id) => {
  return api.get(`/user/${id}`);
};

export const updateVip = (data) => {
  return api.post('/user/vip', data);
};

export const getNewPanListByType = (params) => {
  return api.get('/new-pan/list-by-type', { params });
};

export const getNewPanSearch = (params) => {
  return api.get('/new-pan/search', { params });
};

export const getNewPanDetail = (id) => {
  return api.get('/new-pan/list', { params: { id } });
};
